import { ChangeTracked } from "./index";
import { PlanOptionRuleOption } from "./planoptionruleoption";
import { PlanOptionRuleTemplateTask } from "./planoptionruletemplatetask";

export class AssignedPlanOptionRule {
    planOptionRuleId: number;
    edhPlanId: number;
    optionRuleName: string;
    templateTaskAssignment: PlanOptionRuleTemplateTask & ChangeTracked<PlanOptionRuleTemplateTask>;
    planOptionRuleOptions: PlanOptionRuleOption[] & ChangeTracked<PlanOptionRuleOption>;
}
